import type { ResponsivePropClassNameMap, ResponsiveStyleProp } from 'src/utils'

export type DirectionOption = 'horizontal' | 'vertical'
export type AlignmentOption = 'start' | 'center' | 'end'

const CARD_BREAKPOINTS = ['base', '2xs', 'md', 'lg'] as const

// Returns a string of classNames with the appropriate styling for the direction or alignment
// of the Card at each breakpoint
export function buildResponsivePropDependentClassNames<TOption extends string>(
    spacingClasses: ResponsivePropClassNameMap<TOption>,
    responsivePropVal: ResponsiveStyleProp<TOption>
): string {
    // value for the previous (smaller) breakpoint
    let valForPrevBreakpoint: TOption
    return CARD_BREAKPOINTS.map((breakpoint) => {
        const optionVal: TOption =
            responsivePropVal[breakpoint] ?? valForPrevBreakpoint
        valForPrevBreakpoint = optionVal
        return spacingClasses[breakpoint]?.[optionVal]
    })
        .filter(Boolean)
        .join(' ')
}
